export const cssVar = (name) => `var(${name})`
